import posthog from "posthog-js";
import { appConfig } from "@shared/utils/appConfig";

const MAX_FLAGS_RELOAD_RETRIES = 3;

export const posthogService = {
  init: () => {
    if (!appConfig.POSTHOG_API_KEY) return;

    posthog.init(appConfig.POSTHOG_API_KEY, {
      api_host: "https://z.sidekickdata.io",
      ui_host: "https://us.posthog.com",
      defaults: "2026-01-30",
      disable_session_recording: true,
    });

    let retriesLeft = MAX_FLAGS_RELOAD_RETRIES;
    posthog.onFeatureFlags((_flags, _variants, context) => {
      if (!context?.errorsLoading) {
        retriesLeft = MAX_FLAGS_RELOAD_RETRIES;
        return;
      }
      if (retriesLeft <= 0) return;
      retriesLeft -= 1;
      posthog.reloadFeatureFlags();
    });
  },
};
